const PaginationInfo = ({ totalItems, currentPage, itemsPerPage = 10 , dataName  }) => {
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, totalItems);

    return (
        <span className="text-muted" >{dataName} {startIndex} - {endIndex} of {totalItems}</span>
    );
};

export default PaginationInfo;
